import { utils } from '@hh/global.js'

const { debounce } = utils

class HHLoadMorePagination extends HTMLElement {
  constructor() {
    super()

    this.debouncedOnClick = debounce((event) => {
      this.onClickHandler(event)
    }, 500)

    this.querySelector('.js-load-more-trigger')?.addEventListener(
      'click',
      this.debouncedOnClick.bind(this)
    )
  }

  onClickHandler(event) {
    event.preventDefault()

    const nextPage = event.target.getAttribute('data-next')

    const currentSearchParams = new URLSearchParams(window.location.search)
    currentSearchParams.set('page', nextPage)

    this.broadcast('load-more-grid', {
      params: currentSearchParams.toString()
    })
  }

  broadcast(eventName, eventValue) {
    window.dispatchEvent(
      new CustomEvent(eventName, {
        bubbles: true,
        composed: true,
        detail: {
          value: eventValue,
        },
      })
    )
  }
}

customElements.define('hh-load-more-pagination', HHLoadMorePagination)
